//  @todo: remove commmented code if all fine with menu

import React, { FC, useState, useEffect } from 'react';
// import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
// import { useRecoilValue } from 'recoil'
// import { roomQuantityState } from 'states/SearchBarStates/atoms';
// import { selectedRooms } from 'states/CheckOutStates/atoms';
// import StyledBadge from '../Badge';
// import StyledButton from '../Button'
import { HeaderContainer } from './style';
// import { HeaderIcon } from 'assets/icons';
import { TopMenuBookings, TopMenuAccount, TopMenuSignIn } from 'assets/icons';
// import HeaderMenu from 'components/HeaderMenu';
import { Icon } from 'components/Icon';
import { useAuth } from 'customHooks/useAuth';
import hotelLogo from 'assets/images/rook-logo.svg';
// import { useGetClosestBookingInfo } from 'customHooks/useGetClosestBookingInfo';
// import { styleSizes } from "constants/styleSizes";
// import { useLocation } from 'react-router-dom';

const Header: FC = () => {

  
  const { validToken } = useAuth();
  // const [isActiveIcon, setActiveIcon] = useState(false);
  const [isSignedIn, setIsSignedIn] = useState(!!validToken)
  // const history = useHistory();
  // const roomQuantity = useRecoilValue(roomQuantityState)
  // const persistSelectedRooms = useRecoilValue(selectedRooms)

  // const [showBookNowBotton, setShowBookNowBotton] = useState(false);
  // const [showAddGuestInfoBotton, setShowAddGuestInfoBotton] = useState(false);
  // const [showAddGuestInfoBottonLink, setShowAddGuestInfoBottonLink] = useState('/');

  // const { loading, bookingInfo:closestBookingInfo } = useGetClosestBookingInfo();
  // const location = useLocation();



  // useEffect(() => {
  //   const tabletBreakpointNumber = parseInt(styleSizes.tabletBreakpoint, 10);
  
  //   // Handler to manage UI updates on window resize
  //   const handleResize = () => {
  //     if ((window.innerWidth < tabletBreakpointNumber) && location.pathname == "/account/dashboard") {
  //       if (closestBookingInfo == null) {
  //         setShowBookNowBotton(true);
  //         setShowAddGuestInfoBotton(false);
  //         console.log ("closestBookingInfonull: ", closestBookingInfo);
  //       } else {
  //         setShowBookNowBotton(false);
  //         setShowAddGuestInfoBotton(false);
  //         if (closestBookingInfo.status === "INCOMPLETE") {
  //           setShowAddGuestInfoBotton(true);
  //           setShowBookNowBotton(false);
  //           setShowAddGuestInfoBottonLink(`/account/bookings/add-guest-info/${closestBookingInfo.groupID}/1`);
  //         } else if (closestBookingInfo.status === "CHECKED_OUT") {
  //           setShowBookNowBotton(true);
  //           setShowAddGuestInfoBotton(false);
  //         }
  //       }
  //     } else {
  //       // Reset buttons if the window is larger than the tablet breakpoint
  //       setShowBookNowBotton(false);
  //       setShowAddGuestInfoBotton(false);
  //     }

 
  //     if (debug) {
  //       console.log ("closestBookingInfo: ", closestBookingInfo);
  //       console.log ("showBookNowBotton: ", showBookNowBotton);
  //       console.log ("showAddGuestInfoBotton: ", showAddGuestInfoBotton);
  //     }

  //   };
  
  //   // Call the handler on the initial render to set the correct state
  //   handleResize();
  
  //   // Add event listener to handle window resize
  //   window.addEventListener('resize', handleResize);
  
  //   // Cleanup the event listener on component unmount
  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };

  // }, [closestBookingInfo]);
  

  useEffect(() => {
    setIsSignedIn(!!validToken)
  }, [validToken, setIsSignedIn])

  return (
    <HeaderContainer>
      <div className="innerContainer">
        <Link to="/" className="navTitle">

          <img
            src={hotelLogo}
            alt="Rook Hotel Logo"
            className="hotelLogo"
          />
        </Link>
        <div className="HeaderContent">
          <Link to="/about-us" className="HeaderLink">
            About Rook
          </Link>
          <Link
              to="/contact-us"
              className="HeaderLink"
              >
                Contact us
          </Link>

          {isSignedIn? (
            <React.Fragment>
          <Link
              to="/account/bookings"
              className="HeaderLink"
              >
          <Icon isActiveIcon={false} width={16} height={15}>
            <TopMenuBookings />
          </Icon>
                My bookings
          </Link>
          <Link
              to="/account/dashboard"
              className="HeaderLink"
              >
          <Icon isActiveIcon={false} width={16} height={15}>
            <TopMenuAccount />
          </Icon>
                My account
          </Link>
          </React.Fragment>
          ) : (

          

          <Link
              to="/sign-in"
              className="HeaderLink"
              >
            <Icon isActiveIcon={false} width={16} height={16}>
            <TopMenuSignIn />
          </Icon>
                Sign in
          </Link>
        )}
          {/* {(!showBookNowBotton && !showAddGuestInfoBotton) ?
            <React.Fragment>
              <Link
                to="/discover"
                className="HeaderLink"
              >
              Discover
              </Link>
              <Link
              to="/contact-us"
              className="HeaderLink"
              >
                Contact us
              </Link>
            </React.Fragment>
            :
            null
          } */}



        </div>
        <div className="HeaderContent MobileHeaderContent">

          {isSignedIn? (
            <React.Fragment>
          <Link
            to="/account/bookings"
            className="HeaderLink MobileHeaderLink"
          >
            <Icon isActiveIcon={false} width={16} height={16}>
              <TopMenuBookings />
            </Icon>
          </Link>
          <Link
            to="/account/dashboard"
            className="HeaderLink MobileHeaderLink"
          >
            <Icon isActiveIcon={false} width={16} height={16}>
              <TopMenuAccount />
            </Icon>
          </Link>
          </React.Fragment>
          ):(
            <React.Fragment>
            <Link to="/about-us" className="HeaderLink">
            About Rook
          </Link>
          <Link
            to="/sign-in"
            className="HeaderLink MobileHeaderLink"
          >
            <Icon isActiveIcon={false} width={16} height={16}>
              <TopMenuSignIn />
            </Icon>
          </Link>
          </React.Fragment>
          )}
          
        </div>


        {/* <div className="controlButtons"> */}

          {/* {showBookNowBotton ?
            <StyledButton
              className="bookNowButton"
              width="93px"
              fontSize={14}
              height="38px"
              onClick={() => {
                history.push('/');
              }}
            >
              Book Now
            </StyledButton>
            :
            null
          } */}

          {/* {showAddGuestInfoBotton ?
            <StyledButton
              className="addGuestInfoButton"
              width="120px"
              fontSize={14}
              height="38px"
              onClick={() => {
                history.push(showAddGuestInfoBottonLink);
              }}
            >
              Add Guest Info
            </StyledButton>
            :
            null
          } */}


        {/* {isSignedIn? (
          <StyledButton
          className="signInButton"
          width="63px"
          fontSize={14}
          height="38px"
          onClick={() => userLogout() }
        >
          Logout
        </StyledButton>

        ) : (
          <StyledButton
            className="signInButton"
            width="63px"
            fontSize={14}
            height="38px"
            onClick={() => {
              history.push('/sign-in');
            }}
          >
            Sign in
          </StyledButton>
        )} */}

        
        {/* </div> */}


        {/* <StyledBadge
          className="navBar"
          invisible = {Object.keys(persistSelectedRooms).length === 0}
          badgeContent={roomQuantity}
          onClick={() => {
            setActiveIcon(!isActiveIcon)
          }}
        >
          <Icon isActiveIcon={false}>
            <HeaderIcon />
          </Icon>
          <Icon
            omitted = {!isSignedIn}
            customerStyle
            activeIconStyle            
            isActiveIcon={isActiveIcon}
            style ={{marginRight: '-10px'}}
          >
            <PersonIcon />
          </Icon>
          {isActiveIcon? (
            <div className='menuContainer' ref={componentRef}>
              <HeaderMenu />
            </div>
          ) : null}
        </StyledBadge> */}
      </div>
    </HeaderContainer>
  );
};
export default Header;
